<template>
  <header :class="ns.b()" :style="style">
    <slot />
  </header>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'

import type { CSSProperties } from 'vue'

interface HeaderProps {
  /**
   * @description height of the header
   */
  height?: string | null
}

defineOptions({
  name: 'ZHeader',
})

const props = withDefaults(defineProps<HeaderProps>(), {
  height: null,
})

const ns = useNamespace('header')
const style = computed(() => {
  return props.height
    ? (ns.cssVarBlock({
        height: props.height,
      }) as CSSProperties)
    : {}
})
</script>
